import styled from 'styled-components';

export const SkeletonItemWrapper = styled.div`
  width: 100%;
  height: 300px;
  background-color: ${({ theme }) => theme.palette.white};
  display: flex;
  margin-bottom: 10px;
  position: relative;
`;

export const SkeletonItemFeatureWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 10px;
`;

export const SkeletonItemHeader = styled.div`
  margin-bottom: 40px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.inputBorderColor};
  width: 100%;
`;

export const SkeletonItemMain = styled.div`
  padding: 20px;
`;

export const SkeletonItemDivider = styled.div`
  width: 1px;
  height: 90%;
  background-image: linear-gradient(140deg, #ebebeb 1%, #ededed 52%, #ebebeb);
  position: absolute;
  right: 200px;
  top: 50%;
  transform: translateY(-50%);
`;

export const MobileSkeletonItemWrapper = styled.div`
  width: 100%;
  height: 438px;
  background-color: ${({ theme }) => theme.palette.white};
  margin-bottom: 12px;
  position: relative;
  overflow: hidden;
  padding: 0 12px;
`;

export const MobileSkeletonItemContent = styled.div`
  margin: 10px;
`;

export const MobileSkeletonItemPrice = styled.div`
  position: absolute;
  bottom: 24px;
  right: 15px;
`;
